import { render } from "./RuiAlert.vue?vue&type=template&id=10c64ff6&scoped=true"
import script from "./RuiAlert.vue?vue&type=script&lang=ts"
export * from "./RuiAlert.vue?vue&type=script&lang=ts"

import "./RuiAlert.vue?vue&type=style&index=0&id=10c64ff6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-10c64ff6"

export default script